(ns basic-components.inputs.email
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.utils :as fu]
   [reagent.core :as r]))


(defn render
  [dom-atom args]
  (let [{:keys [:value :placeholder :class-name
                :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled?]}
        args
        edit-value (or (:temp-value @dom-atom) value)
        render-value (str (if (nil? edit-value) value edit-value))
        clear-state! (fn []
                       (swap! dom-atom dissoc :temp-value))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (or placeholder "")
             :class-name  (fu/cs "input-area" (when has-focus? "focus") class-name)
             :value       render-value
             :on-focus    (fn [e]
                            (.select (:input-dom-node @dom-atom)) ;; all desktop browsers - select all text
                            (when on-focus!
                              (on-focus! e)))
             :on-change   (fn [e]
                            (let [new-value (-> e
                                                .-target
                                                .-value)]
                              (swap! dom-atom assoc :temp-value new-value)
                              (when on-change!
                                (on-change! e new-value))))
             :on-blur     (fn [e]
                            (when on-blur!
                              (on-blur! e render-value clear-state!)))
             :on-key-down on-key-down!}
            (when disabled?
              {:disabled true}))]))


(defmethod editor :editor.type/email
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Email"
      :component-did-mount    (fn [args]
                                (let []
                                  ;; we use this to know where focus is changing - we can prevent blur if focus is changing to
                                  ;; events withing this editor if needed

                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/email
  [args]
  (str (:value args)))

(defmethod viewer :editor.type/email
  [args]
  (r/create-class
   {:display-name   "Email/viewer"
    :reagent-render (fn [args]
                      (let [value (:value args)]
                        [:div.preview.preview-email
                         (when-not (or (nil? value) (and (string? value) (empty? value)))
                           [:a {:href (str "mailto:" value)}
                            (display-string args)])]))}))
